import React, { useState } from 'react';
import ScrollMenu from 'react-horizontal-scroll-menu';
import BrandHeroCarousel from 'components/commons/BrandHeroCarousel';
import CarrouselProducts from 'components/commons/CarrouselProducts';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { productsArrayPropTypes, slidersArrayPropTypes } from 'helpers/propTypes';
import { sectionsArray } from './constants';

import Loading from 'components/commons/Loading';
import Benefit from 'components/commons/Benefit';
import { isSlideImage, useRenderableHeroSliders } from 'helpers/sliders';

import './Home.scss';

const Home = (props) => {
  const {
    cartel, categoriesHome, currentSection, currentSection1, instagram, items, loadingProd, loadingMostSelled,
    marcasHome, mostSelled, mostSelledClick, offers, onSectionClick, renderItem,
    sliders, subCategoriesHome, client, loading, minimumPurchase,
  } = props;

  const [activeNew, setActiveNew] = useState(0);
  const {
    heroSliders,
    markHeroSlideReady,
    markHeroSlideFailed,
  } = useRenderableHeroSliders(sliders);

  // ---------------- Tabs (diseño 0)
  const deriveTabKey = (section, idx) => {
    if (section && Object.prototype.hasOwnProperty.call(section, 'value')) return String(section.value);
    const label = (section && section.label ? section.label : '').toLowerCase();
    if (label.includes('oferta')) return 'offers';
    if (label.includes('vend')) return 'most';
    if (label.includes('nuevo')) return 'new';
    if (label.includes('todo')) return 'all';
    return `tab-${idx}`;
  };

  const initialTabKey = sectionsArray && sectionsArray.length
    ? deriveTabKey(sectionsArray[0], 0)
    : 'all';
  const [activeTabKey, setActiveTabKey] = useState(initialTabKey);

  const handleTabClick = (section, idx) => {
    const key = deriveTabKey(section, idx);
    setActiveTabKey(key);
    if (typeof onSectionClick === 'function') {
      const nextVal = (section && Object.prototype.hasOwnProperty.call(section, 'value')) ? section.value : idx;
      onSectionClick(nextVal);
    }
  };

  const getVisibleProductsForDesign0 = () => {
    if ((activeTabKey === 'most' || /vend/i.test(String(activeTabKey))) && mostSelled && mostSelled.length) {
      return mostSelled;
    }
    if ((activeTabKey === 'offers' || /ofert/i.test(String(activeTabKey))) && offers && offers.length) {
      return offers;
    }
    return items;
  };
  const visibleProducts = getVisibleProductsForDesign0();

  // ---------------- Filtro local (fallback) para diseño 1
  const [pos0Filter, setPos0Filter] = useState(
    typeof currentSection === 'number' ? currentSection : -1
  );
  const [pos1Filter, setPos1Filter] = useState(
    typeof currentSection1 === 'number' ? currentSection1 : -1
  );

  const getSubId = (p) =>
    (p && (
      p.subCategory_id ||
      p.subcategory_id ||
      (p.subcategory && p.subcategory.id) ||
      (p.subCategory && p.subCategory.id) ||
      p.sub_category_id
    )) || null;

  const filterBySubId = (source, subId) => {
    if (!Array.isArray(source)) return [];
    if (subId === -1 || subId === null || subId === undefined) return source;
    return source.filter((p) => getSubId(p) === subId);
  };

  const handleFilterPos0 = (subCatOrUndefined) => {
    const next = subCatOrUndefined && subCatOrUndefined.subCategory_id
      ? subCatOrUndefined.subCategory_id
      : -1;
    setPos0Filter(next);
    if (typeof onSectionClick === 'function') onSectionClick(subCatOrUndefined);
  };

  const handleFilterPos1 = (subCatOrUndefined) => {
    const next = subCatOrUndefined && subCatOrUndefined.subCategory_id
      ? subCatOrUndefined.subCategory_id
      : -1;
    setPos1Filter(next);
    if (typeof mostSelledClick === 'function') mostSelledClick(subCatOrUndefined);
  };

  const itemsPos0 = filterBySubId(items, pos0Filter);
  const itemsPos1 = filterBySubId(mostSelled, pos1Filter);

  // ---------------- Nuevos ingresos
  const nuevosIngresos = [...items].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const filteredNuevosIngresos = nuevosIngresos.slice(0, 20);

  const renderSilder = () => {
    if (!heroSliders.length) return null;

    if (heroSliders.length === 1) {
      const slide = heroSliders[0];
      return (
        <div data-testid="slider" className="hero-carousel">
          <div className="main-slider">
            {isSlideImage(slide) ? (
              <img
                className="main-slider-img"
                src={slide.image}
                alt={slide.text}
                loading="eager"
                decoding="async"
                onLoad={() => markHeroSlideReady(slide)}
                onError={() => markHeroSlideFailed(slide)}
              />
            ) : (
              <video
                src={slide.image}
                autoPlay
                muted
                loop
                controls
                playsInline
                preload="auto"
                className="main-slider-video"
                onLoadedData={() => markHeroSlideReady(slide)}
                onError={() => markHeroSlideFailed(slide)}
              >
                <track kind="captions" srcLang="en" label="English_captions" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        </div>
      );
    }

    return (
      <BrandHeroCarousel
        sliders={sliders}
        variant={`design-${client?.design ?? 'default'}`}
      />
    );
  };

  const renderScrollMenu = () => (
    <div className="section">
      <div className="navbar-categories">
        <ScrollMenu
          alignCenter={false}
          arrowDisabledClass="scroll-menu-arrow--disabled"
          arrowLeft={<span className="arrow-prev">{' < '}</span>}
          arrowRight={<span className="arrow-next">{' > '}</span>}
          data={marcasHome.map((category) => (
            <Link key={category.category.id} to={`/productos/${category.category.code}`}>
              <img alt={category.category.name} src={category.category.image} />
            </Link>
          ))}
          dragging={false}
          hideSingleArrow
          wheel={false}
        />
      </div>
    </div>
  );

  const renderMarcasHome = () => (
    <div className="section">
      <div className="marcasHome">
        {marcasHome.map((category) => (
          <Link key={category.category.id} to={`/productos/${category.category.code}`}>
            <img alt={category.category.name} src={category.category.image} style={{ width: '100%' }} />
          </Link>
        ))}
      </div>
    </div>
  );

  const renderItems = (productos, onClickMetod, current, pos, isLoading) => (
    <div className="section">
      {/* {subCategoriesHome.filter((subCategory) => (subCategory.position === pos)).length > 0 && (
        <div className="row align-items-center">
          <div className="col text-center">
            <div className="new-arrivals-sorting">
              <ul className="arrivals-grid-sorting clearfix button-group filters-button-group">
                <li
                  className={`grid-sorting-button button ${current === -1 ? 'active' : ''}`}
                  onClick={() => { if (typeof onClickMetod === 'function') onClickMetod(); }}
                  role="presentation"
                >
                  Todos los productos
                </li>
                {subCategoriesHome
                  .filter((subCategory) => (subCategory.position === pos))
                  .map((subCategorie) => (
                    <li
                      className={`grid-sorting-button button ${subCategorie.subCategory_id === current ? 'active' : ''}`}
                      data-testid={`section-${subCategorie.subCategory_id}`}
                      key={subCategorie.subCategory_id}
                      onClick={() => { if (typeof onClickMetod === 'function') onClickMetod(subCategorie); }}
                      role="presentation"
                    >
                      {subCategorie.category.name}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      )} */}

      <div className="row align-items-center product-slider-container" data-testid="carousel">
        {isLoading && <Loading />}
        {!isLoading && (
          <>
            {!productos.length && <h4 className="text-center">No se encontraron productos</h4>}
            {!!productos.length && productos.map(renderItem)}
          </>
        )}
      </div>
    </div>
  );

  // ---------------- Diseño 2 (igual que lo tenías)
  if (client && client.design === 2) {
    return (
      <div data-testid="home-page">
        {renderSilder()}
        <div className="container">
          <div className="row">
            <div className="col">
              {marcasHome.length > 0 && (<>{renderScrollMenu()}</>)}
            </div>
          </div>
        </div>

        {categoriesHome.length >= 4 && (
          <div className="section categorias-grid">
            <div className="row">
              {categoriesHome.slice(0, 4).map(cat => (
                <div className="col-md-6 mb-6 column-flex" key={cat.category.id}>
                  <div className="img-button img-button-sandy">
                    <Link to={`/productos/${cat.category.code}`}>
                      <img alt={cat.category.name} src={cat.category.imageHome} style={{ width: '100%', objectFit: 'cover' }} />
                      <button type="button">{cat.category.name}</button>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="container">
          <div className="row">
            <div className="col">
              <div className="section nuevos-ingresos">
                {filteredNuevosIngresos.length > 0 && (
                  <>
                    <div className="newarrivals-title">
                      <div className="line" />
                      <span className="newArrival-title-text">NUEVOS INGRESOS</span>
                      <div className="line" />
                    </div>
                    <CarrouselProducts
                      products={filteredNuevosIngresos}
                      active={activeNew}
                      onChangeActive={setActiveNew}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ---------------- Diseños 0 y 1
  return (
    <div data-testid="home-page">
      {renderSilder()}

      {client && !!client.design ? (
        // ===== Diseño 1 con fallback local en subcategorías =====
        <div className="container">
          <div className="row">
            <div className="col">

              {/* {marcasHome.length > 0 && (<>{renderMarcasHome()}{renderScrollMenu()}</>)} */}

              {categoriesHome.length === 5 ? (
                <div className="section">
                  <div className="category-images">
                    <div className="row">
                      <div className="col-lg-6" style={{ alignContent: 'center' }}>
                        <div className="img-button column-flex">
                          <img alt={categoriesHome[0].category.name} src={categoriesHome[0].category.imageHome} />
                          <Link to={`/productos/${categoriesHome[0].category.code}`}>
                            <button type="button">{categoriesHome[0].category.name}</button>
                          </Link>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="row">
                          <div className="col-6 column-flex">
                            <div className="img-button column-flex">
                              <img alt={categoriesHome[1].category.name} src={categoriesHome[1].category.imageHome} />
                              <Link to={`/productos/${categoriesHome[1].category.code}`}>
                                <button type="button">{categoriesHome[1].category.name}</button>
                              </Link>
                            </div>
                          </div>
                          <div className="col-6 column-flex">
                            <div className="img-button column-flex">
                              <img alt={categoriesHome[2].category.name} src={categoriesHome[2].category.imageHome} />
                              <Link to={`/productos/${categoriesHome[2].category.code}`}>
                                <button type="button">{categoriesHome[2].category.name}</button>
                              </Link>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-6 column-flex">
                            <div className="img-button column-flex">
                              <img alt={categoriesHome[3].category.name} src={categoriesHome[3].category.imageHome} />
                              <Link to={`/productos/${categoriesHome[3].category.code}`}>
                                <button type="button">{categoriesHome[3].category.name}</button>
                              </Link>
                            </div>
                          </div>
                          <div className="col-6 column-flex">
                            <div className="img-button column-flex">
                              <img alt={categoriesHome[4].category.name} src={categoriesHome[4].category.imageHome} />
                              <Link to={`/productos/${categoriesHome[4].category.code}`}>
                                <button type="button">{categoriesHome[4].category.name}</button>
                              </Link>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {items.length ? (
                <div className="section">
                  <div className="row align-items-center">
                    <div className="col text-center info-container">
                      <a href={() => false}>Conocé nuestros productos</a>
                    </div>
                  </div>

                  {/* Pos 0: usa itemsPos0 y estado local pos0Filter */}
                  {renderItems(
                    itemsPos0,
                    handleFilterPos0,
                    pos0Filter,
                    0,
                    loadingProd
                  )}
                </div>
              ) : null}

              {!!cartel[0] && (
                <div className="imgCartel-container">
                  <img 
                    src={cartel[0].image} 
                    alt={cartel[0].category.name} 
                    className="imgCartel-fluid" 
                  />
                  <div className="infoCartel-overlay">
                    {/* <div className="description-container">
                      <span>{cartel[0].category.name}</span>
                    </div>
                    <div className="description-container">
                      <p className="banner-text">{cartel[0].description}</p>
                    </div> */}
                    <div className="description-container">
                      <Link to={`/productos/${cartel[0].category.code}`}>
                        <button className="btn-coleccion">VER COLECCIÓN</button>
                      </Link>
                    </div>
                  </div>
                </div>
              )}

              {mostSelled.length ? (
                <div className="no-movil">
                  <div className="section">
                    <div className="row align-items-center">
                      <div className="col text-center info-container">
                        <a href={() => false}>Los más vendidos</a>
                      </div>
                    </div>
                  </div>

                  {/* Pos 1: usa itemsPos1 y estado local pos1Filter */}
                  {renderItems(
                    itemsPos1,
                    handleFilterPos1,
                    pos1Filter,
                    1,
                    loadingMostSelled
                  )}
                </div>
              ) : null}

              {offers.length ? (
                <div className="section">
                  <div className="row align-items-center">
                    <div className="col text-center info-container">
                      <a href={() => false}>Nuestras Ofertas</a>
                    </div>
                  </div>
                  {renderItems(offers.slice(0, 15), null, null, 2, false)}
                </div>
              ) : null}

              {instagram.length > 0 && (
                <>
                  <div className="section">
                    <div className="row align-items-center">
                      <div className="col text-center info-container">
                        <a href={() => false}>Seguinos en Instagram </a>
                        <a href="https://www.instagram.com/lenceriavellaneda/">@lenceriavellaneda</a>
                      </div>
                    </div>
                  </div>
                  <div className="section social-media">
                    {instagram.map((publicacion) => (
                      <div className="instagram-image" key={publicacion.link}>
                        <iframe
                          title="instagram"
                          src={`${publicacion.link}embed`}
                          className="instagram-iframe"
                          frameBorder="0"
                          scrolling="no"
                          allowtransparency="true"
                        />
                      </div>
                    ))}
                  </div>
                </>
              )}

            </div>
          </div>
        </div>
      ) : (
        // ===== Diseño 0 (tabs simples)
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="section">
                <Benefit minimumPurchase={minimumPurchase} />
              </div>

              <div className="section">
                {/* <div className="row align-items-center">
                  <div className="col text-center d-flex justify-content-center">
                    <div className="new-arrivals-sorting">
                      <ul className="arrivals-grid-sorting clearfix button-group filters-button-group">
                        {sectionsArray.map((section, idx) => {
                          const key = deriveTabKey(section, idx);
                          const isActive = key === activeTabKey;
                          return (
                            <li
                              className={`simple-grid-sorting-button button ${isActive ? 'active' : ''}`}
                              data-testid={`section-${key}`}
                              key={key}
                              onClick={() => handleTabClick(section, idx)}
                              role="presentation"
                            >
                              {section && section.label ? section.label : `Sección ${idx + 1}`}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div> */}

                <div className="row align-items-center product-slider-container" data-testid="carousel">
                  {loading && <Loading />}
                  {!loading && (
                    <>
                      {!visibleProducts.length && <h4 className="text-center">No se encontraron productos</h4>}
                      {!!visibleProducts.length && visibleProducts.map((item) => renderItem(item))}
                    </>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Home.defaultProps = {
  tiktok: null,
};

Home.propTypes = {
  cartel: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  categoriesHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  currentSection: PropTypes.number.isRequired,
  currentSection1: PropTypes.number.isRequired,
  instagram: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  items: productsArrayPropTypes.isRequired,
  loading: PropTypes.bool.isRequired,
  marcasHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  mostSelled: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  mostSelledClick: PropTypes.func.isRequired,
  offers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onSectionClick: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  sliders: slidersArrayPropTypes.isRequired,
  subCategoriesHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  tiktok: PropTypes.string,
  client: PropTypes.shape({
    design: PropTypes.number,
  }),
  loadingProd: PropTypes.bool,
  loadingMostSelled: PropTypes.bool,
  minimumPurchase: PropTypes.number,
};

export default Home;
